import { render } from "./ThePositionEditDialog.vue?vue&type=template&id=34a06bb2&ts=true"
import script from "./ThePositionEditDialog.vue?vue&type=script&lang=ts"
export * from "./ThePositionEditDialog.vue?vue&type=script&lang=ts"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__